import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { designSlice } from "store/slices/design";

const { setPreviewDesign } = designSlice.actions;

export const PreviewUrlHandler: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const ngPreviewParam = urlParams.get("ngpreview");
        if (ngPreviewParam === "1" || ngPreviewParam === "0") {
            dispatch(setPreviewDesign(ngPreviewParam === "1" ? "new" : "legacy"));

            urlParams.delete("ngpreview");
            const newSearch = urlParams.toString();
            const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "");

            window.history.replaceState(null, "", newUrl);
        }
    }, [dispatch]);
    return null;
};
